<template>
  <div class="advantage-items">
    <div class="item" v-for="(item, index) in advantageInfo"
      :key="index"
      :class="{'no-margin': ((index == advantageInfo.length - 1) || (index == advantageInfo.length - 2)), 'no-margin-right' : (index % 2 != 0)}">
      <div class="icon-container"  :style="{backgroundImage:'url(' + item.iconLogo + ')'}"></div>
      <div class="text-info">
        <div class="title">{{item.title}}</div>
        <div class="content">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['advantageInfo']
};
</script>

<style lang="less" scoped>
.advantage-items{
  width: 1170px;
  margin: 0 auto;
  font-size: 0;
  div{
    box-sizing: border-box;
  }
  .item{
    width: 540px;
    display: inline-block;
    font-size: 0;
    margin-bottom: 58px;
    margin-right: 90px;
    .icon-container, .text-info{
      display: inline-block;
      vertical-align: top;
    }
    .icon-container{
      width: 160px;
      height: 160px;
      background-repeat: no-repeat;
      background-position: 0, 78px 0px;
    }
    .text-info{
      padding-left: 40px;
      width: 380px;
      .title{
        text-align: left;
        font-size: 22px;
        margin-bottom: 26px;
        color: #242526;
        line-height: 30px;
      }
      .content{
        text-align: justify;
        color: #242526;
        line-height: 1.8;
        font-size: 16px;
      }
    }
    &.no-margin {
      margin-bottom: 0;
    }
    &.no-margin-right{
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/common/SchemeAdvantage.vue